export default "__VITE_ASSET__bwxtt5if__"